module.exports = __webpack_public_path__ + "static/media/terms-icon.e8105db7.svg";